import styled from 'styled-components';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ReactComponent as ArrowLeft } from '../../images/icons/arrowleft.svg';
import { ReactComponent as ArrowRight } from '../../images/icons/arrownext.svg';

const DefaultElementColor = styled.div`
  ${(props) => props.defaultColor}
`;

export default function Pagination(props) {
  const { prevPageFn, nextPageFn, currentPage, totalPages } = props;

  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  const defaultColor = `
    background-color: ${primaryColour};
  `;

  const renderButtons = () => {
    const maxPages = totalPages;
    const items = [];
    let leftSide = currentPage - 2;
    if (leftSide <= 0) leftSide = 1;
    let rightSide = currentPage + 2;
    if (rightSide > maxPages) rightSide = maxPages;

    for (let number = leftSide; number <= rightSide; number += 1) {
      items.push(
        <div
          key={number}
          className={`pagination rounded-full flex justify-center align-middle items-center ${
            number === currentPage ? 'font-bold active' : ''
          }`}
        >
          {number}
        </div>,
      );
    }

    return items;
  };

  return (
    <>
      <DefaultElementColor
        defaultColor={defaultColor}
        className="pagination-arrows rounded-full flex justify-center align-middle"
      >
        <button type="button" onClick={() => prevPageFn()}>
          <ArrowLeft className="w-5" />
        </button>
      </DefaultElementColor>
      {renderButtons()}
      <DefaultElementColor
        defaultColor={defaultColor}
        className="pagination-arrows rounded-full flex justify-center align-middle"
      >
        <button type="button" onClick={() => nextPageFn()}>
          <ArrowRight className="w-5" />
        </button>
      </DefaultElementColor>
    </>
  );
}
